import { pixelToNumber, tokens } from 'ComponentLibrary'

const INTER_12_AVERAGE_CHAR_WITH = 5.7 // optimistic estimate

export const estimateLabelWidth = (text: string) => text.length * INTER_12_AVERAGE_CHAR_WITH + pixelToNumber(tokens.SizingSpacing200)
